import {observable, action} from 'mobx';

class Event {
  @observable event = null;
  @observable id = null;
  @observable time = null;
  @observable editing = false;
  @observable personId = null;

  constructor(event) {
    this.setId(event.id);
    this.setPersonId(event.personId);
    this.setEvent(event.event);
    this.setTime(event.time);
  }

  @action setId = id => {
    this.id = id;
  };

  @action setPersonId = personId => {
    this.personId = personId;
  };

  @action setEvent = event => {
    this.event = event;
  };

  @action setEditing = editing => {
    this.editing = editing || !this.editing;
  };

  @action setTime = time => {
    if (time / 10000000000 > 1) {
      // time was in milliseconds, set it
      this.time = time;
    } else {
      // time was not in milliseconds, so multiply by 1000
      this.time = time * 1000;
    }
  }
}

export default Event;


// WEBPACK FOOTER //
// ./src/views/Beeper/Event.js